import { render, staticRenderFns } from "./McpJson.vue?vue&type=template&id=79f16b49&scoped=true"
import script from "./McpJson.vue?vue&type=script&lang=js"
export * from "./McpJson.vue?vue&type=script&lang=js"
import style0 from "./McpJson.vue?vue&type=style&index=0&id=79f16b49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f16b49",
  null
  
)

export default component.exports